import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStarBadge = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 70,
	height: 87,
	viewBox: "0 0 70 87",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M58.1612 57.8424C60.6548 55.3034 62.7396 52.3647 64.3021 49.1262C64.7609 48.1724 65.1742 47.1958 65.5421 46.1966C65.7238 45.6969 65.8964 45.1882 66.0553 44.6795C66.5323 43.1443 66.9002 41.5637 67.1454 39.9421C67.3953 38.3206 67.5224 36.6582 67.5224 34.9686C67.5224 34.4508 67.5088 33.9421 67.4816 33.4288C67.4816 33.3561 67.477 33.2835 67.4725 33.2108C67.4452 32.7248 67.4089 32.2479 67.3635 31.7664C67.3544 31.6756 67.3453 31.5847 67.3362 31.4939C67.2862 31.0215 67.2272 30.5491 67.1545 30.0813C67.1409 30.0041 67.1318 29.9269 67.1182 29.8497C67.041 29.3637 66.9592 28.8822 66.8593 28.4007C66.8593 28.3826 66.8502 28.3599 66.8457 28.3417C66.7503 27.8739 66.6413 27.4151 66.5277 26.9564C66.5095 26.8837 66.4914 26.8065 66.4732 26.7338C66.3551 26.2887 66.2325 25.8481 66.0962 25.4075C66.069 25.3121 66.0372 25.2168 66.0054 25.1214C65.8691 24.6899 65.7238 24.2629 65.5739 23.845C65.5421 23.7542 65.5057 23.6679 65.4739 23.5771C65.315 23.1456 65.1469 22.7186 64.9698 22.2962C64.9471 22.2462 64.9289 22.2008 64.9062 22.1509C64.7381 21.7557 64.561 21.3696 64.3793 20.9835C64.3384 20.9018 64.3021 20.8155 64.2612 20.7337C64.0704 20.3431 63.8706 19.957 63.6662 19.5755C63.6117 19.471 63.5527 19.3666 63.4982 19.2621C63.2938 18.8897 63.0848 18.5217 62.8623 18.1584C62.8032 18.0585 62.7396 17.9585 62.676 17.8541C62.4535 17.4907 62.2218 17.1273 61.9856 16.773C61.9357 16.6958 61.8812 16.6232 61.8267 16.5459C61.6132 16.2325 61.3906 15.9237 61.1681 15.6194C61.0999 15.5285 61.0363 15.4377 60.9682 15.3468C60.7184 15.0198 60.4641 14.6928 60.2052 14.3748C60.1189 14.2658 60.0325 14.1614 59.9417 14.0569C59.6828 13.748 59.4194 13.4437 59.1514 13.1439C59.056 13.0395 58.9652 12.9395 58.8698 12.8351C58.5973 12.5398 58.3247 12.2491 58.0431 11.9675C57.9568 11.8812 57.866 11.7949 57.7797 11.7086C57.5299 11.4634 57.2755 11.2226 57.0212 10.9865C56.9303 10.9002 56.8395 10.8139 56.7441 10.7321C56.4443 10.4641 56.14 10.2007 55.8311 9.94178C55.7176 9.8464 55.604 9.75101 55.4905 9.66017C55.4496 9.62838 55.4133 9.59204 55.3724 9.56025C55.3724 9.56025 55.3815 9.56933 55.3815 9.57387C49.772 5.04089 42.641 2.32019 34.8695 2.32019C16.833 2.32019 2.21204 16.9411 2.21204 34.9777C2.21204 42.7491 4.93272 49.8847 9.4657 55.4896C9.4657 55.4896 9.45664 55.4805 9.45209 55.4805C9.48389 55.5214 9.52021 55.5578 9.55201 55.5986C9.64739 55.7122 9.74277 55.8257 9.83816 55.9393C10.0971 56.2482 10.356 56.5525 10.624 56.8477C10.7103 56.9431 10.7966 57.0339 10.8829 57.1293C11.11 57.3746 11.3416 57.6153 11.5732 57.856L2.5754 74.5027C2.02581 75.5202 2.8661 76.7329 4.0107 76.5739L12.9767 75.343L16.8557 83.5233C17.3507 84.5679 18.8269 84.6088 19.3765 83.5914L28.3516 66.9901C28.8149 67.0855 29.2782 67.1673 29.7506 67.24C29.8278 67.2536 29.905 67.2672 29.9868 67.2763C30.4546 67.3444 30.927 67.4035 31.3994 67.458C31.4902 67.4671 31.581 67.4761 31.6719 67.4852C32.1488 67.5307 32.6302 67.567 33.1117 67.5942C33.1844 67.5942 33.2616 67.5988 33.3343 67.6033C33.843 67.626 34.3563 67.6442 34.8695 67.6442C37.1042 67.6442 39.2799 67.4171 41.3874 66.9901L50.3625 83.5914C50.9121 84.6088 52.3883 84.5725 52.8833 83.5233L56.7623 75.343L65.7283 76.5739C66.8775 76.7329 67.7177 75.5202 67.1636 74.5027L58.1658 57.856L58.1612 57.8424Z",
			stroke: "white",
			strokeWidth: 4.42397,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.842 83.5097L12.963 75.3294L3.99699 76.5603C2.84785 76.7193 2.01212 75.5065 2.56171 74.4891L15.2977 50.934L32.1033 60.0181L19.3674 83.5733C18.8178 84.5907 17.3416 84.5543 16.8465 83.5051L16.842 83.5097Z",
			fill: "url(#paint0_linear_43_274)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M52.8788 83.5097L56.7577 75.3294L65.7237 76.5603C66.8729 76.7193 67.7086 75.5065 67.159 74.4891L54.4231 50.934L37.6174 60.0181L50.3534 83.5733C50.903 84.5907 52.3791 84.5543 52.8742 83.5051L52.8788 83.5097Z",
			fill: "url(#paint1_linear_43_274)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M34.8604 67.626C52.8966 67.626 67.5178 53.0047 67.5178 34.9685C67.5178 16.9323 52.8966 2.31104 34.8604 2.31104C16.8241 2.31104 2.20288 16.9323 2.20288 34.9685C2.20288 53.0047 16.8241 67.626 34.8604 67.626Z",
			fill: "url(#paint2_linear_43_274)"
		}),
		/* @__PURE__ */ _jsx("path", {
			style: { mixBlendMode: "color-burn" },
			opacity: .15,
			d: "M55.3633 9.54666C59.8918 15.1516 62.6034 22.2826 62.6034 30.0495C62.6034 48.0861 47.9824 62.707 29.9459 62.707C22.179 62.707 15.0479 59.9954 9.44299 55.467C15.4294 62.8796 24.5908 67.6215 34.865 67.6215C52.9015 67.6215 67.5224 53.0006 67.5224 34.9641C67.5224 24.6944 62.7805 15.5331 55.3678 9.54211L55.3633 9.54666Z",
			fill: "url(#paint3_linear_43_274)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.8278 16.9638L41.1738 28.1236L53.442 29.7588C54.3367 29.8769 54.691 30.9761 54.0415 31.5983L45.08 40.1329L47.3147 52.3056C47.4782 53.1913 46.5426 53.8726 45.7477 53.4411L34.8604 47.5546L23.973 53.4411C23.1827 53.8681 22.2471 53.1913 22.406 52.3056L24.6407 40.1329L15.6792 31.5983C15.0252 30.9761 15.384 29.8769 16.2788 29.7588L28.5469 28.1236L33.8929 16.9638C34.2835 16.1507 35.4372 16.1507 35.8278 16.9638Z",
			fill: "#EFA226"
		}),
		/* @__PURE__ */ _jsx("path", {
			style: { mixBlendMode: "soft-light" },
			d: "M32.3555 30.9295C40.9908 24.9946 44.8857 15.6653 41.0552 10.0917C37.2246 4.51821 27.119 4.81111 18.4838 10.746C9.84853 16.6808 5.95357 26.0102 9.78415 31.5837C13.6147 37.1572 23.7203 36.8643 32.3555 30.9295Z",
			fill: "url(#paint4_linear_43_274)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_43_274",
				x1: 10.2232,
				y1: 80.4019,
				x2: 26.283,
				y2: 50.7,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .18,
						stopColor: "#40201C"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .55,
						stopColor: "#633328"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .92,
						stopColor: "#8B4A37"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_43_274",
				x1: 59.4994,
				y1: 80.396,
				x2: 43.4375,
				y2: 50.69,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .18,
						stopColor: "#40201C"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .55,
						stopColor: "#633328"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .92,
						stopColor: "#8B4A37"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_43_274",
				x1: 34.8603,
				y1: 64.2194,
				x2: 34.8603,
				y2: -6.63684,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .07,
						stopColor: "#F9DF4B"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .27,
						stopColor: "#F6D347"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .48,
						stopColor: "#F6D047"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .74,
						stopColor: "#F4BC41"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .77,
						stopColor: "#F3BA40"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#F3B53F"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_43_274",
				x1: 28.5424,
				y1: 23.2546,
				x2: 50.8621,
				y2: 62.975,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#221F20"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_43_274",
				x1: 14.4538,
				y1: 7.2667,
				x2: 45.7123,
				y2: 46.0514,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "white" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .34,
						stopColor: "#B6B5B5"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#221F20"
					})
				]
			})
		] })
	]
});
export default SvgStarBadge;
